import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=020bd0ce&scoped=true&"
import script from "./Footer.vue?vue&type=script&lang=js&"
export * from "./Footer.vue?vue&type=script&lang=js&"
import style0 from "./Footer.vue?vue&type=style&index=0&id=020bd0ce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "020bd0ce",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TopFooterForm: require('/opt/build/repo/apps/shop/components/TopFooterForm.vue').default,TopFooterLinks: require('/opt/build/repo/apps/shop/components/TopFooterLinks.vue').default,DownloadAppIcons: require('/opt/build/repo/apps/shop/components/storyblok/DownloadAppIcons/DownloadAppIcons.vue').default,BottomFooter: require('/opt/build/repo/apps/shop/components/BottomFooter.vue').default})
